import type { ExchangeBetslipCapabilities } from "../contract";

const DEFAULT_EXCHANGE_CAPABILITIES: ExchangeBetslipCapabilities = {
  bestPriceExecution: { enabled: false },
  bspBetting: { enabled: false },
  eachWayExposureDisplay: { enabled: false },
};

export const resolveExchangeCapabilities = (
  overrides: Partial<ExchangeBetslipCapabilities> = {},
): ExchangeBetslipCapabilities => ({ ...DEFAULT_EXCHANGE_CAPABILITIES, ...overrides });
